import script from "./MainResetPasswordComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./MainResetPasswordComponent.vue?vue&type=script&setup=true&lang=js"

import "./MainResetPasswordComponent.vue?vue&type=style&index=0&id=a685b72e&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a685b72e"]])

export default __exports__